<template>
    <div id="login">
        <h1></h1>
        <h2></h2>
        <div class="blank">
            <i></i>
            <input type="text"
                   name="username"
                   id="username"
                   v-model="info.phone"
                   placeholder="输入手机号">
        </div>
        <div class="blank">
            <i></i>
            <input type="password"
                   name="password"
                   id="password"
                   v-model="info.password"
                   placeholder="输入密码">
        </div>
        <input type="submit"
               value="登录"
               @click="submit"
               class="login active">
    </div>
</template>

<script >
let Base64 = require('js-base64').Base64;
export default {
    data () {
        return {
            info: {
                phone: '',
                password: '',
                user_type: 3,   //3教师  1 学生
                login_type: 1,
                platform: 1
            }
        }
    },
    methods: {
        submit () {//登录
            let vm = this;
            let obj = Object.assign({}, this.info)
            obj.phone = obj.phone.slice(0, 11);
            obj.phone = Base64.encode(obj.phone);
            obj.password = Base64.encode(obj.password);
            this.$http.post(API_URL_BASE_API + '/account/login/', obj).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    if (res.data.length) {
                        localStorage.setItem("Tbkt-Token", res.data[0].tbkt_token);
                        this.getProfile();
                    }
                    layer.alert('登录成功！', 'tea', function (index) {
                        vm.$router.push('/');
                        layer.close(index);
                    })
                } else {
                    layer.alert(res.message);
                }
            })
        },
        getProfile(){
            this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
                if (res.data.response === 'ok') {
                    let r = res.data.data;
                    localStorage.setItem('info', JSON.stringify(r));
                    if (r.units.length) {
                        if (r.units[0].city_id == "411600") {
                            localStorage.setItem('city_id', "411600");
                        } else {
                            localStorage.setItem('city_id', "");
                        }
                    }
                }
            })
        }
    },
    created () {
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#login {
    height: 100vh;
    background: url("./img/bg.png") no-repeat top #70dbff;
    background-size: 100% auto;
    position: relative;
}

h1 {
    background: url("./img/logo.png") no-repeat;
    width: 160px / $ppr;
    height: 160px / $ppr;
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    top: 128px / $ppr;
}

h2 {
    background: url("./img/word.png") no-repeat;
    width: 128px / $ppr;
    height: 42px / $ppr;
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    top: 140px / $ppr;
}

.blank {
    height: 88px / $ppr;
    line-height: 88px / $ppr;
    background: #fff;
    text-align: left;
    padding: 0 40px / $ppr;
    font-size: 30px / $ppr;
    width: 600px / $ppr;
    color: #333;
    margin: 30px / $ppr auto 0;
    border-radius: 44px / $ppr;
    i {
        background: url("./img/pwd.png") no-repeat;
        width: 32px / $ppr;
        height: 38px / $ppr;
        background-size: 100% 100%;
        display: inline-block;
        position: relative;
        top: 10px / $ppr;
    }
    input {
        border: none;
        background-color: #fff;
        color: #aaa;
        margin-left: 30px / $ppr;
    }
    &:nth-of-type(1) {
        margin-top: 200px / $ppr;
        border-bottom: $line solid 1px / $ppr;
        i {
            background: url("./img/phone.png") no-repeat;
            width: 28px / $ppr;
            height: 38px / $ppr;
            background-size: 100% 100%;
        }
    }
}

.login {
    width: 675px / $ppr;
    height: 84px / $ppr;
    line-height: 84px / $ppr;
    border: none;
    border-radius: 42px / $ppr;
    background: #ffda10;
    color: #e6bf10;
    font-size: 36px / $ppr;
    margin: 60px / $ppr auto 0;
    display: block;
    &.active {
        background: #ffda10;
        color: #e6bf10;
    }
}

p {
    text-align: left;
    margin-left: 20px / $ppr;
    line-height: 60px / $ppr;
    color: #555;
    font-size: 24px / $ppr;
}
</style>
